import React from 'react';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: November 4, 2025</p>
        </header>

        <section className="privacy-section">
          <h2>1. About This Application</h2>
          <p>
            This Law Firm Management Application ("the App") is an internal business tool operated by the
            <strong> Law Offices of Rozsa Gyene</strong> (State Bar No. 208356) exclusively for managing client
            workflows, communications, and legal services.
          </p>
          <p>
            This App is <strong>not available to the general public</strong> and is used solely by authorized
            personnel of our law firm to provide professional legal services to our clients.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Information We Collect</h2>
          <p>As part of our legal practice, we collect and manage the following information:</p>
          <ul>
            <li><strong>Client Information:</strong> Names, email addresses, phone numbers, and case details</li>
            <li><strong>Case Data:</strong> Workflow information for estate planning, probate, and trust administration matters</li>
            <li><strong>Communications:</strong> Email drafts created through Gmail integration for client correspondence</li>
            <li><strong>Documents:</strong> Legal documents stored via Google Drive integration</li>
            <li><strong>Appointments:</strong> Calendar events managed through Google Calendar integration</li>
            <li><strong>Financial Records:</strong> Invoice and payment information related to legal services</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>3. How We Use Your Information</h2>
          <p>Information collected through this App is used exclusively for:</p>
          <ul>
            <li>Providing professional legal services to our clients</li>
            <li>Managing client workflows and case progress</li>
            <li>Communicating with clients regarding their legal matters</li>
            <li>Storing and organizing legal documents</li>
            <li>Scheduling appointments and deadlines</li>
            <li>Processing payments and maintaining financial records</li>
            <li>Complying with professional legal and ethical obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>4. Data Protection and Confidentiality</h2>
          <p>
            As a law firm, we are bound by attorney-client privilege and professional ethical rules. We maintain
            strict confidentiality of all client information:
          </p>
          <ul>
            <li>We <strong>do NOT sell, rent, or share</strong> client data with third parties</li>
            <li>We <strong>do NOT use</strong> client data for marketing or advertising purposes</li>
            <li>Client information is protected by attorney-client privilege</li>
            <li>Access to the App is restricted to authorized law firm personnel only</li>
            <li>All data is transmitted and stored securely using industry-standard encryption</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>5. Third-Party Services</h2>
          <p>This App integrates with the following Google services to provide functionality:</p>
          <ul>
            <li><strong>Gmail API:</strong> For creating email drafts to communicate with clients</li>
            <li><strong>Google Calendar API:</strong> For managing appointments and deadlines</li>
            <li><strong>Google Drive API:</strong> For secure document storage</li>
          </ul>
          <p>
            These integrations are used solely for the purposes described above. Google's use of information
            received from these APIs adheres to the{' '}
            <a
              href="https://developers.google.com/terms/api-services-user-data-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google API Services User Data Policy
            </a>, including the Limited Use requirements.
          </p>
        </section>

        <section className="privacy-section">
          <h2>6. Data Retention</h2>
          <p>
            We retain client information in accordance with professional legal requirements and California State
            Bar rules governing record retention for legal matters. Client data may be retained for the duration
            of legal representation and for the period required by law thereafter.
          </p>
        </section>

        <section className="privacy-section">
          <h2>7. Your Rights</h2>
          <p>As our client, you have the right to:</p>
          <ul>
            <li>Request access to your information</li>
            <li>Request corrections to your information</li>
            <li>Request information about how your data is used</li>
            <li>Receive copies of documents related to your legal matter</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>8. Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your information
            against unauthorized access, alteration, disclosure, or destruction. This includes:
          </p>
          <ul>
            <li>Secure authentication and access controls</li>
            <li>Encrypted data transmission (HTTPS/SSL)</li>
            <li>Regular security assessments</li>
            <li>Restricted access to authorized personnel only</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. The "Last Updated" date at the top of this
            page indicates when this policy was last revised. Any changes will be effective immediately upon
            posting.
          </p>
        </section>

        <section className="privacy-section">
          <h2>10. Contact Information</h2>
          <p>
            If you have any questions about this Privacy Policy or how we handle your information, please contact us:
          </p>
          <div className="contact-info">
            <p><strong>Law Offices of Rozsa Gyene</strong></p>
            <p>State Bar No. 208356</p>
            <p>Email: <a href="mailto:rozsagyenelaw1@gmail.com">rozsagyenelaw1@gmail.com</a></p>
            <p>Website: <a href="https://livingtrust-attorneys.com" target="_blank" rel="noopener noreferrer">livingtrust-attorneys.com</a></p>
          </div>
        </section>

        <footer className="privacy-footer">
          <p>© {new Date().getFullYear()} Law Offices of Rozsa Gyene. All rights reserved.</p>
          <p>
            This privacy policy applies to the Law Firm Management Application at{' '}
            <a href="https://management.livingtrust-attorneys.com">management.livingtrust-attorneys.com</a>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
